export default __webpack_public_path__ + "static/Routhem - Regular-2e8980911e30be847bc46bf6b570c6a2.otf";